import React, { useEffect, useState } from "react";
import Slider from "src/components/slider";
import Panel from "../animation/panel";
import Reveal from "src/components/animation";
import {generateLink, invalidateAllLinks, invalidateAllUpdations, resetGenerateLinks } from "src/redux/actions/link";
import { fetchNDARequest } from "src/redux/actions/ndaTemplate";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Asset } from "src/types/assets";
import { Collection } from "src/types/collections";

import {LinkContainer, AnonymousLinkContainer} from "./components/linkContainer";
import ManageLinks from "./components/manageLinks";
import LinkSettings from "./components/linkSettings";
import { GenerateLinkRequest, Link } from "src/types/link";

import _ from "lodash";
import cx from "classnames";
import styles from "./generateLink.module.scss";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
interface GenerateLinkProps {
  onClose: () => void;
  entity: Asset | Collection;
}
const GenerateLink: React.FC<GenerateLinkProps> = ({ onClose, entity }) => {
  const dispatch = useDispatch();
  const  {trackGenerateLinkScreenView, trackAssetShareLinkGenerated} = useAssetAdoption();

  useEffect(() => {
    //adoption
    trackGenerateLinkScreenView();

    dispatch(fetchNDARequest());
  }, []);

  const linkObject = useSelector((state: any) => _.get(state, "link", null));
  const link: Link = _.get(linkObject.generateLink, "link", {
    type: "anonymous",
    id: "",
  });

  const [currentTab, setCurrentTab] = useState<string>("generate_link");
  const [email, setEmail] = useState<string>("");
  const [campaignTag, setCampaignTag] = useState<string>("");
  const [showLinkSettings, setShowLinkSettings] = useState<boolean>(false);
  const [showManageLinks, setShowManageLinks] = useState<boolean>(false);

  const textContent = {
    title: "generate link",

    manage_links: {
      title: "manage links",
    },
    personalised: {
      title: "Personalized Link",
      sub_text: "Who's the lucky prospect? Create a special link for them.",
      placeholder: "Enter recipient email here",
    },
    anonymous: {
      title: "Anonymous Link",
      sub_text:
        "Chop chop. Share content quickly. And don't worry, user-level tracking can be enabled with email gating in 'Advanced Settings'. ",
    },
    campaign: {
      title: "Executing a new campaign?",
      sub_text:
        "Don't be shy. Enter the name of your campaign and any additional information to generate a UTM link.",
      placeholder: "Enter campaign tag here",
    },
  };

  const handleClose = () => {
    dispatch(resetGenerateLinks())
    onClose();
  };
  const handleCampaignTagChange = (value: string) => {
    setCampaignTag(value);
  };
  const handleEmailChange = (value: string) => {
    setEmail(value);
  };
  const handleGenerateLink = (request: GenerateLinkRequest) => {
    dispatch(
      generateLink({
        entityID: entity.id,
        entityType: entity.entityType,
        ...request,
      }),
    );

    trackAssetShareLinkGenerated();
  };
  const handleShowSettings = (flag: boolean) => {
    setShowLinkSettings(!showLinkSettings);
  };
  const generateHeader = () => {
    if (currentTab === "generate_link") {
      return (
        <div className={styles.header}>
          <p className={styles.title}>{textContent.title}</p>
          <i className={cx("paperflite-close",styles.closeIcon)} onClick={handleClose} />
        </div>
      );
    } else if (currentTab === "manage_links") {
      return (
        <div className={styles.header}>
          <div className={cx(styles.title)}>
            <i
              className={cx(
                'paperflite-left-arrow',
                styles.fadeInRight,
                styles.backArrow,
              )}
              onClick={() => {
                setShowManageLinks(!showManageLinks);
                setCurrentTab("generate_link");
              }}
            />
            <span className={styles.manageLinktitle}>{textContent.manage_links.title}</span>
          </div>
          <i className={cx("paperflite-close",styles.closeIcon)} onClick={handleClose} />
        </div>
      );
    }
  };

  return (
    <div className={cx(styles.container)}>
      <Slider.Header title={generateHeader()} />
      <Slider.Body>
        <section className={cx(styles.content)}>
          <Reveal show={showLinkSettings}>
            <LinkSettings
              link={link}
              textContent={textContent}
              onClose={() => {
                dispatch(invalidateAllUpdations({id:link.id}))
                dispatch(invalidateAllLinks())
                setShowLinkSettings(!showLinkSettings)

              }}
            />
          </Reveal>

          <section
            className={cx(styles.linkSections, {
              [styles.slideLeft]: showManageLinks || showLinkSettings,
            })}
          >
            <LinkContainer
              className={styles.personalised}
              link={link}
              linkType="personalised"
              value={email}
              entity={entity}
              setValue={handleEmailChange}
              linkMetaData={textContent.personalised}
              handleShowSettings={handleShowSettings}
              handleGenerateLink={handleGenerateLink}
              setCurrentTab={setCurrentTab}
            />

            <AnonymousLinkContainer
              linkType="anonymous"
              link={link}
              linkMetaData={textContent.anonymous}
              entity={entity}
              handleShowSettings={handleShowSettings}
              handleGenerateLink={handleGenerateLink}
              setCurrentTab={setCurrentTab}

            />

            <LinkContainer
              link={link}
              linkType="campaign"
              handleGenerateLink={handleGenerateLink}
              value={campaignTag}
              entity={entity}
              setValue={handleCampaignTagChange}
              linkMetaData={textContent.campaign}
              handleShowSettings={handleShowSettings}
              setCurrentTab={setCurrentTab}

            />

          </section>
            <Panel show={showManageLinks} className={styles.manageLinks}>
              <section className={styles.manageLinks}>
                <ManageLinks entity={entity} />
              </section>
            </Panel>
        </section>
      </Slider.Body>

      {!showLinkSettings && !showManageLinks && (
        <span
          className={cx(styles.manageLinksButton)}
          onClick={() => {
            dispatch(invalidateAllLinks());
            setCurrentTab("manage_links");
            setShowManageLinks(!showManageLinks);
          }}
        >
          <i className="paperflite-menu" />
          Manage links
        </span>
      )}
    </div>
  );
};

export default React.memo(GenerateLink);
